import Brooklyn from './brooklyn';
import Debut from './debut';
import Express from './express';
import Minimal from './minimal';
import Narrative from './narrative';
import Simple from './simple';
import Supply from './supply';
import Venture from './venture';

const PRESETS = {
    Brooklyn,
    Debut,
    Express,
    Minimal,
    Narrative,
    Simple,
    Supply,
    Venture
};

export default PRESETS;
